<template>
  <div class="article-details">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-d-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{isCH ? '首页' : 'Home'}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/academicField' }">{{isCH ? '学术场域' : 'Academic field'}}</el-breadcrumb-item>
        <template v-for="(item,index) in titleList">
          <el-breadcrumb-item :key="index" v-if="item.columnCode === columnCode">{{isCH ? item.title : item.titleE}}</el-breadcrumb-item>
        </template>
      </el-breadcrumb>
    </div>
    <div v-if="info" class="article">
      <div class="title"><strong>{{info.articleTitle}}</strong></div>
      <div class="author">{{info.articleAuthor}}</div>
      <div v-html="isCH ? info.articleDetails : info.articleDetails2" class="content"></div>
    </div>
  </div>

</template>
<script>
import { articleDetails } from '@/api/academic'
import { checkLanguage } from "@/utils/check"

export default {
  data() {
    return {
      isCH: checkLanguage(),
      titleList: [
        { title: '学术论坛', titleE: 'Academic Forum', columnCode: '010401' },
        { title: '学术专著', titleE: 'Academic monograph', columnCode: '010402' },
        { title: '学术论文', titleE: 'Academic papers', columnCode: '010403' }
      ],
      columnCode: '',
      info: null
    }
  },
  created() {
    this.columnCode = this.$route.query.columnCode
    this.getDetails(this.$route.query.id)
  },
  methods: {
    getDetails(id) {
      articleDetails({ id }).then(res => {
        if (res.code === 10000) {
          this.info = res.data
        }
      })
    }
  }
}
</script>
<style lang="scss">
.article-details {
  flex: 1;
  width: 1140px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  .breadcrumb {
    width: 1140px;
    margin: 0 auto;
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 0 0 45px;
  }
  .article {
    .title {
      color: #3e3a39;
      font-size: 18px;
      line-height: 18px;
      margin: 37px 0 18px 0;
      text-align: center;
      font-weight: bolder;
    }
    .author {
      font-size: 14px;
      line-height: 14px;
      text-align: center;
      color: #595757;
      margin: 0 0 40px 0;
    }
    .content {
      padding: 0 45px 30px;
    }
    li {
      list-style: inherit;
      margin: 0 0 0 14px;
    }
  }
}
</style>